import nvSharedModelsModule from '../nv.shared.models.module';

angular.module(nvSharedModelsModule).factory('Tool', function(NvBaseModel, PublicConfig, $http) {
  const PERMISSIONING_MODEL_NAME = 'TOOL';

  const Tool = NvBaseModel(
    '/v1/tools/:id/',
    { id: '@_id', schoolId: '@schoolId' },
    null,
    null,
    PERMISSIONING_MODEL_NAME,
  );

  return Tool;
});
